var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImogiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#imogiIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.992 4C7.576 4 4 7.584 4 12C4 16.416 7.576 20 11.992 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 11.992 4ZM12 18.4C8.464 18.4 5.6 15.536 5.6 12C5.6 8.464 8.464 5.6 12 5.6C15.536 5.6 18.4 8.464 18.4 12C18.4 15.536 15.536 18.4 12 18.4ZM14.8 11.2C15.464 11.2 16 10.664 16 10C16 9.336 15.464 8.8 14.8 8.8C14.136 8.8 13.6 9.336 13.6 10C13.6 10.664 14.136 11.2 14.8 11.2ZM9.2 11.2C9.864 11.2 10.4 10.664 10.4 10C10.4 9.336 9.864 8.8 9.2 8.8C8.536 8.8 8 9.336 8 10C8 10.664 8.536 11.2 9.2 11.2ZM12 16.4C13.864 16.4 15.448 15.232 16.088 13.6H7.912C8.552 15.232 10.136 16.4 12 16.4Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "imogiIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImogiIcon);
export default __webpack_public_path__ + "static/media/imogiIcon.5b23a1aeb71fbd00cb2d56c8a043d4b4.svg";
export { ForwardRef as ReactComponent };